import React from 'react';
import { BsLock } from 'react-icons/bs';
import { Button, FormLabel, Icon, InputGroup, InputLeftElement, InputRightElement } from '@chakra-ui/react';
import PropTypes from 'prop-types';

function PasswordInputGroup({ children,
  show,
  label,
  onClick }) {
  return (
    <>
      <FormLabel
        htmlFor="password"
        textStyle="bodyMd600"
        w="100%"
      >
        {label}
      </FormLabel>
      <InputGroup size="md">
        <InputLeftElement children={<Icon as={BsLock} color="primaryScale.700" />} pointerEvents="none" />
        {children}
        <InputRightElement width="4.5rem">
          <Button
            colorScheme="brand"
            fontWeight="400"
            h="1.75rem"
            size="xs"
            variant="accent"
            onClick={onClick}
          >
            {show ? 'hide' : 'show'}
          </Button>
        </InputRightElement>
      </InputGroup>
    </>
  );
}

PasswordInputGroup.propTypes = {
  children: PropTypes.element,
  label: PropTypes.string,
  show: PropTypes.bool,
  onClick: PropTypes.func
};

export default PasswordInputGroup;
